import { API_END_POINT, axiosInstance, DataType } from '@app-store'

export const fetchMissingInformationData = async (
  caseId: string | undefined
) => {
  return await axiosInstance.get(
    `${API_END_POINT.WORKFLOW}/missing-info/${caseId}`
  )
}

export const updateManualMissingFields = async (data: DataType[]) => {
  return await axiosInstance.post(
    `${API_END_POINT.WORKFLOW}/missing-info/update-manual-mi`,
    data
  )
}

export const getAllLovs = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.WORKFLOW}/missing-info/search`
  )
}

export const validateCase = async (caseId: string | undefined) => {
  return await axiosInstance.patch(
    `${API_END_POINT.WORKFLOW}/missing-info/validate?caseId=${caseId}`
  )
}
